let privacyPolicyEN = require('../privacyPolicy/privacyPolicy_en')
let ENV = process.env

module.exports = {
  navbar: {
    language: 'English',
    myAccount: 'Account',
    setting: 'Setting',
    signOut: 'Sign Out'
  },
  modal: {
    modalCancel: 'Cancel',
    modalOk: 'OK',
    modalChange: 'Change'
  },
  country: {
    jp: 'Japan',
    cn: 'China'
  },
  status: {
    back: 'Back',
    save: 'Save',
    cancel: 'Refuse',
    reSubmit: 'Confirm Material',
    receipt: 'Accept Application',
    rateConfirm: 'Determine Rate ',
    transferred: 'Finish Transaction',
    AC: 'Application Complete',
    GU: 'Cancelled',
    WC: 'Coin Transfer Confirming',
    C: 'Terminated',
    RA: 'Coin Transfer Confirmed',
    CR: 'Rate Determined',
    PC: 'Transaction Complete'
  },
  orderInfoModal: {
    title: 'confirm',
    save: 'Are you sure to save the application information?',
    statusAC: 'Are you sure to ask the customer to resend the transfer information about the coin?',
    statusC: 'If you cancel the application, no operation can be performed anymore. Are you sure to do that?',
    statusRA: 'Are you sure that the coin is transferred to the specified account?',
    statusCR: 'Are you sure that you have type the correct exchange rate?',
    statusPC: 'Are you sure that all the processes of the application are done?',
    copperRate: 'Copper Rate',
    rate: 'Exchange Rate',
    amount: 'Amount',
    charge: 'Service Fee',
    operatorMessage: 'Message from Service Staff',
    status: 'Status',
    successTitle: 'Message',
    successMessage: 'Success in application status change',
    successButton: 'Back to Application List'
  },
  login: {
    welcome: 'Welcome back to the service',
    explain: 'Please sign in.',
    email: 'E-Mail',
    emailPlaceholder: 'Please input the e-mail',
    emailRequired: 'Please input the e-mail',
    password: 'Password',
    passwordPlaceholder: 'Please input the Password',
    passwordRequired: 'Please input the Password',
    login: 'Sign In',
    signUp: 'Sign up',
    signUpText: 'If you do not have an account',
    message: 'Something wrong in e-mail or password'
  },
  forgotPassword: {
    forgotPasswordText: 'Forgot password?',
    modalTitle: 'Forgot password',
    message: 'Message',
    sendEmailSuccess: 'Email has been sent to your email. Please check the email to complete password reset.',
    passwordChangeSuccess: 'Password has been changed, please return to the login interface to login.'
  },
  top: {
    mytheme: 'Frequently Used Menus',
    myorder: 'Exchange Application',
    mysettings: 'Setting',
    Previous: 'Previous',
    Next: 'Next'
  },
  /**
     * orderHome
     */
  ordertop: {
    myhome: 'Home'
  },
  CreateOrder: {
    neworder: 'New application',
    pointOut: 'You can exchange your vitual currency here. At the point, the service only supports BTC to USD. Press the button below to create a new application.',
    createbutton: 'New Application'
  },
  orderList: {
    titleList: 'Application List',
    textList: 'You can check the proceeding and past Application ',
    listbutton: 'Show Applications'
  },
  /**
     * OrderCreate
     */
  OrderCreate: {
    OrderCreate: 'New Application',
    Terms: 'Service Term',
    Input: 'Input',
    Confrim: 'Confirm',
    Complete: 'Complete',
    text: 'Fill in the information below to create a new application. Exchange rate which is shown below is a reference value, and not garunteed. We will contact you the exact rate where is rate is determined. '
  },
  /**
     * OrderCreate-Terms
     */
  OrderTerms: {
    TermsTitle: 'SCALES Terms of Service',
    confirmed: 'I agree the service term above.',
    BackButton: 'Back',
    NextButton: 'Confirm',
    CreateButton: 'Apply'
  },
  /**
     * OrderCreate-Currency
     */
  OrderCurrency: {
    amountOfCurrency: 'Coin Amount',
    amountOfCurrencyTips: 'Please input the Coin Amount',
    BTC: 'BTC',
    referenceExchangeRate: 'Reference Rate',
    referenceExchangeRateTips: 'Please note that the rate here is a reference, which is different from the exact rate. ',
    budgetEstimate: 'Estimated Exchange Amount',
    budgetEstimateTips: 'Please note that this value is calculated based on the rate above, and is different from the exact amount. ',
    serviceCharge: 'Service Fee',
    serviceChargeTips: 'As a service fee, you need to pay 2% of estimated amount. ',
    traded: 'The estimated amount is exceeding 1 million USD. Please change the coin amount to make estimated amount within 1 million USD. '
  },
  /**
     * TwiceVerification
     */
  TwiceVerification: {
    modalSubmit: 'Submit',
    verificationCodeExplainLogin: 'Input MFA Code to complete the operation',
    verificationCodeExplainOrder: 'Input MFA Code to complete the operation',
    verificationCodeExplainInfo: 'Input MFA Code to complete the operation',
    twiceVerification: 'MFA Authencation',
    verificationCode: 'MFA Code：',
    verificationCodePlaceholder: 'Please input the MFA Code',
    verificationCodeRequired: 'Please input the MFA Code',
    bindAuthenticator: 'Vitual MFA Device Setting',
    SetVerificationCodeStep1: 'Install the MFA application into your mobile device. ',
    SetVerificationCodeStep2: 'Use MFA application and the camera of your device to scan the QR Code. ',
    UrlCopy: 'Also, you can input secret key manually',
    SetVerificationCodeStep3: 'Please input the MFA Code',
    Copy: 'Copy to Clipboard',
    CopySuccess: 'Success to copy!'
  },
  /**
     * OrderApplication completed
     */
  ApplicationCompleted: {
    Applicationcompleted: 'New exchange application is created. ',
    pointOut: 'Thanks for the exchange application. Next, you need to transfer your coins to the address which is written in the confirm e-mail. After the transfer, send us the TXID and evidence (screen capture) in application detail page. ',
    ReturnButton: 'Back to Application List'
  },
  /**
     * OrderListTOP
     */
  OrderListTop: {
    OrderList: 'Application List'
  },
  /**
     * OrderList SearchBar
     */
  SearchColumn: {
    NO: 'Application No.',
    Status: 'Status',
    All: 'All',
    search: 'Search'
  },
  /**
     * All
     */
  AllSearchBar: {
    AC: 'Application Complete',
    GU: 'Cancelled',
    WC: 'Coin Transfer Confirming',
    C: 'Terminated',
    RA: 'Coin Transfer Confirmed',
    CR: 'Rate Determined',
    PC: 'Transaction Complete'
  },
  /**
     * orderList page
     */
  orderlist: {
    AppInfo: 'Application Information',
    Transaction: 'Coin Transfer Information',
    CoinPS: 'Coin Transfer Address',
    CoinA: 'Coin Amount',
    CoinTXID: 'TXID',
    TXIDTips: 'TXID is generated when you transfer the coins. Copy the TXID shown in the transfer result page, and paste it into the text box.',
    Evidence: 'Evidence（Screen Capture）',
    Category: 'Exchange Transfer Destination',
    isFairFX: 'Sub-account',
    notFairFx: 'Bank',
    FairFXnum: 'Account Mail Address',
    FairFXnumTipe: 'Please input the Account Mail Address',
    ExchangeRI: 'Exchange Rate Information',
    ConfirmCopperRate: 'Determined Copper Rate',
    ConfirmEdexchangeRate: 'Determined Exchange Rate',
    ConfirmedAmount: 'Determined Exchange Amount',
    ServiceCharge: 'Service Fee',
    ExchangeRIR: 'Exchange Rate (When applied)',
    ConfirmEdexchangeRateR: 'Reference Rate',
    ConfirmedAmountR: 'Estimated Amount',
    ServiceChargeR: 'Service Fee',
    JP: 'Japan',
    CN: 'China',
    ContactMatters: 'Contact',
    Operatormessage: 'Message from Service Staff',
    Usermessage: 'Message from the customer',
    USD: 'USD',
    Savebtn: 'Save',
    Giveup: 'Refuse',
    Request: 'Upload Evidence',
    userInfo: 'Customer Information',
    name: 'Name',
    email: 'E-Mail',
    tel: 'Tel No.',
    copperRateRequired: 'Please input the Determined Copper Rate',
    newRateRequired: 'Please input the Determined Exchange Rate',
    mailLanguage: 'Mail Contact Language',
    limit: 'Up to 1000 records are shown.',
    lower: 'Determined exchange rate is lower than 90% of Reference Rate.<br>Please DO NOT proceed the operation and ask your leader for the next action. ',
    before: 'Before',
    after: 'After',
    ImgUpload: 'Upload image'
  },
  OListinfoxin: {
    fairFX: 'Sub-account',
    accountHolderNameTips: 'Please input the Account Holder Name',
    myResidenceTips: 'Please input the Customer Address (Street)',
    mycityTips: 'Please input the Customer Address (City)',
    myPostalCodeTips: 'Please input the Customer Address (Postal Code)',
    accountNumberTips: 'Please input the Account Number',
    bankName: 'Please input the Bank Name',
    bankStreet: 'Please input the Bank Address (Street)',
    bankCity: 'Please input the Bank Address (City)',
    firstName: 'Please input the First Name',
    lastName: 'Please input the Last Name',
    bankPostcode: 'Please input the Bank Address (Postal Code)',
    bankSWIFT: 'Please input the Bank SWIFT Code'
  },
  /**
     * orderListPopupseven page
     */
  orderListPopup: {
    Confirm: 'Confirm',
    Tips: 'Are you sure to save the application information?',
    Tipsgiup: 'Are you sure to refuse the application?',
    Tipsrequ: 'Are you sure to send the TXID and upload the transfer evidence?',
    UserMessage: 'Message from the customer',
    savesuccessful: 'Success to change the application information',
    retrunorderList: 'Back to Applicationm list',
    change: 'Success to change the application status',
    Messgae: 'Message',
    uploadFileOut: 'Failed to upload image,Please upload picture below 5MB',
    uploadFileTypeWrong: 'Failed to upload image,Please upload picture',
    Evidence: 'Evidence',
    EvidenceTips: `You can check <a href="${ENV.EVIDENCE}" target="_blank">here</a> to confirm the sample screen capture.`,
    EvidenceIntr: `Please take a screenshot of Transaction ID <br />
    on the following page <br />
    (<a href="https://www.blockchain.com/explorer" target="_blank">https://www.blockchain.com/explorer</a>)`
  },
  /**
     * OrderList DisplayBar
     */
  DisplayBar: {
    Application: 'Create Date',
    UpdateTime: 'Update Date',
    filter: 'Filter',
    PreviousButton: 'Previous',
    NextButton: 'Next',
    FirstButton: 'First',
    LastButton: 'Last'
  },
  /**
     * SettingsPage
     */
  Settingspage: {
    SettingsTop: 'Setting',
    UpdateInfo: 'Customer Information',
    Tips: 'You can change the basic information, transfer address and language for contact here.',
    UpdateButton: 'Change',
    UpdatePassword: 'Sign In Password',
    UpdatePsdTips: 'You can change your sign-in password here.',
    UpdateTwofactauth: 'MFA Information',
    UpdateTwofactauthTips: 'You can reset your MFA information when you lost your device or change your MFA applcation. '
  },
  /**
     * SettingUpdateInfoPage
     */
  UpdateInfoTop: {
    UpdateInfo: 'Change Customer Infomation',
    Input: 'Input',
    Confirm: 'Confirm',
    Complete: 'Complete',
    text: 'You can change the basic information, transfer address and language for contact here.'
  },
  /**
     *  Setting UpdateInfoPage Form
     */
  UpdateInfoForm: {
    UserInforTitle: 'Basic Information',
    MyName: 'Name',
    MyNameTips: 'Please input the Name',
    MyTelephone: 'Tel No.',
    TelephoneTips: 'Please input the Tel No.',
    TelephoneTips1: 'Please input the correct Tel No.',
    language: 'Language for Contact',
    FairFX: 'Sub-account Account Information',
    FairFXNumber: 'Account Mail Address',
    BankAccount: 'Bank Account Information',
    accountHolderName: 'Account Holder Name',
    accountHolderNameTips: 'Please input the Account Holder Name',
    myResidence: 'Customer Address (Street)',
    mycity: 'Customer Address (City)',
    myPostalCode: 'Customer Address (Postal Code)',
    mycountry: 'Customer Address (Country)',
    IBAN: 'User Address',
    accountNumber: 'Account No.',
    bankName: 'Bank Name',
    bankStreet: 'Bank Address (Street)',
    bankCity: 'Bank Address (City)',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankPostcode: 'Bank Address (Postal Code)',
    bankCountry: 'Bank Address (Country)',
    bankSWIFT: 'SWIFT CODE',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    Backbtn: 'Back',
    Confirmbtn: 'Confirm',
    Changebtn: 'Change'
  },
  /**
     * UpdateInfo Complete Page
     */
  UpdateComplete: {
    Complete: 'Customer information change was successful.',
    ReturnSettings: 'Back to Settings'
  },
  /**
     * Update password Page
     */
  UpdatePasswordPage: {
    UpdatePassword: 'Change Password',
    Tips: 'You can change the sign-in password here.',
    CurrentPassword: 'Current Password',
    ErrorPormpt: 'Please input the Current Password',
    NewsPassword: 'New Password',
    ErrorPormptnewspad: 'Please input the New Password',
    VerifyPassword: 'New Password(Confirm)',
    ErrorPormptVerify: 'Please input the New Password(Confirm)',
    notMatch: 'New Password and New Password (Confirm) do not match',
    Cancelbtn: 'Cancel',
    Changebtn: 'Change',
    Updatesucceeded: 'Password change was successful.'
  },
  RegisterPage: {
    Terms: 'Service Terms',
    Input: 'Input',
    Confrim: 'Confirm',
    Complete: 'Complete',
    center: 'SCALES Terms of Service',
    Confirm: 'I agree the Service Terms.',
    Next: 'Next'
  },
  Registerform: {
    UserInforTitle: 'Customer Information',
    Email: 'E-Mail',
    MyName: 'Name',
    MyNameTips: 'Please input the Name',
    MyTelephone: 'Tel No,',
    TelephoneTips: 'Please input the Tel No,',
    TelephoneTips1: 'Please input the correct Tel No.',
    language: 'Language for Contact',
    FairFX: 'Sub-account Account Information',
    FairFXNumber: 'Account Mail Address',
    BankAccount: 'Bank Account Infomation',
    accountHolderName: 'Account Holder Name',
    accountHolderNameTips: 'Please input the Account Holder Name',
    myResidence: 'Customer Address (Street)',
    mycity: 'Customer Address (City)',
    myPostalCode: 'Customer Address (Postal Code)',
    mycountry: 'Customer Address (Country)',
    IBAN: 'User Address',
    accountNumber: 'Account No.',
    bankName: 'Bank Name',
    bankStreet: 'Bank Address (Street)',
    bankCity: 'Bank Address (City)',
    bankPostcode: 'Bank Address (Postal Code)',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankCountry: 'Bank Address (Country)',
    bankSWIFT: 'SWIFT CODE',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    successful: 'Sign up was successful.',
    logininterface: 'Please click the button below to jump to the Sign In page',
    Login: 'Sign In',
    Backbtn: 'Back',
    Confirmbtn: 'Confirm',
    Changebtn: 'Change',
    Regist: 'Sign Up'
  },
  languageChoice: {
    English: 'English',
    Japanese: '日本語',
    Chinese: '中文(简体)'
  },
  LandingForm: {
    Email: 'Email',
    Emailplaceholder: 'Enter your email',
    emailTips: 'Please input the correct email address.',
    Password: 'Password',
    Passwordplaceholder: 'Enter your password',
    PasswordTips: 'Please enter your password.',
    Repeatpassword: 'Repeat password',
    Repeatpsdplaceholder: 'Repeat your password',
    RepeatpsdTips: 'Please enter your password again.',
    PsdAndPassword: 'The password and confirm password do not match.',
    Signup: 'Sign up',
    SigninLeft: 'Already have an account? ',
    Signin: 'Sign in',
    TwitterLink: ENV.TWITTER_LINK
  },
  Landing: {
    Scales: 'Scales',
    text1: 'Why increase the',
    text2: 'useless plastic?',
    text3: 'Taking lessons from history <br/> Innovating the Future',
    text4: 'Sustainable Exchange Service',
    tryToService: 'Try the Service'
  },
  LandingCentertext1: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Sustainable Exchange Service (SES) provided by Scales, provides you a high-level privacy protective crypt currency account.',
    Sustainable: 'Sustainable',
    WhereverText: 'By using Sustainable Exchange Service (SES), you can have a trusted account which is protected from country risk.',
    Secure: 'Secure',
    WheneverText: 'Scales is cooperating with British big bank and financial provider to give you the ability to manage your assets.',
    Convenience: 'Convenience',
    WhoeverText: 'According to your purpose, you can choose appropriate way to manage your assets. Every operation only needs a few clicks.'
  },
  LandingCentertext2: {
    textTop1: 'Commonly called Crypt <br/> Currency Card',
    textTop2: 'To use exist services, you usually need a complicated procedure such as purchase cards, sign up for the application, install the application, and an expensive initial cost. Besides, services might be terminated unexpectedly because of the change of country regulations. Also, accounts might become unavailable when service card is expired in a few years.'
  },
  LandingCentertext3: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Regarding our service, you can sign up only by a few clicks. Your assets is protected in trusted banks so you do not need to worry whether the account is safe, whether the service is available, etc. You can also transfer your currency to any bank account all over the world. Besides, even if the debit card issued by the bank become available, it do nothing to the account. Your whole assets will be 360-degree protected.',
    text1: 'EXCHANGE',
    text2: 'TRANSFER',
    text3: 'Or',
    text4: 'Secure Foreign Account <br/> ※Not Subject to CRS'
  },
  LandingCentertext4: {
    textTop1: 'Secure',
    textTop2: 'Scales is cooperating with British big bank and financial provider to give you the ability to manage your assets.'
  },
  LandingCentertext5: {
    textTop1: 'Convenience',
    textTop2: 'You can start the service by just signing up with your e-mail address. You are only asked to submit the KYC according to your transaction amount. Also, we provide several ways to manage your assets.'
  },
  LandingCentertext6: {
    textTop1: 'Method 1 (Easy to Start)',
    textTop2: 'Exchange your currency to your own bank',
    textTop3: 'Method 2 (Recommended)',
    textTop4: 'Exchange your currency to your PayGlobal Account',
    text1: 'Easy <br/> Start',
    text2: 'Create an account',
    text3: 'Exchange',
    text4: 'Please tell me your bank <br/> account information.',
    text5: 'Receive cash',
    text6: 'SUBACCOUNT',
    step1: 'STEP ONE',
    step2: 'STEP TWO',
    step3: 'STEP THREE',
    step4: 'STEP FOUR'
  },
  LandingBottom1: {
    Title: 'Who we are',
    Title2: 'working with',
    TitleTips: 'We cooperate with highly trusted bank and financial providers. So you do not need to worry anything about your assets.'
  },
  registSuccess: {
    Title: 'Thanks for your registration.',
    TitleTips: 'To continue the registration, please follow the instruction in the mail that we sent to your mailbox.',
    OK: 'OK'
  },
  ClientMessage: {
    timeout: 'Network timeout.',
    Request: 'Request error.',
    title: 'Message',
    Retrybtn: 'Retry',
    Cancelbtn: 'Cancel',
    OKbtn: 'OK',
    page404: 'Page not found.',
    page500: 'Internal error.',
    Undefinederroe: 'Undefined status code:',
    page1001: 'Failed on parameter validator.',
    page1002: 'Failed on login.',
    page1003: 'Unauthorized request.',
    page1004: 'Failed on request.',
    page1005: 'Failed on file validator.',
    page1006: 'Unauthorized request.',
    page1007: 'Timeout. Please login again.',
    page9001: 'Internal error.',
    page9002: 'Unknown error.(9002)',
    Unknownerror: 'Unknown error.',
    login: 'login'
  },
  privacyPolicy: {
    registerPrivacyPolicy: privacyPolicyEN
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/i18n/en.js